import Decimal from 'decimal.js';

export const truncatedTwoDecimalNumber = (num: number): number => Math.trunc(num * 100) / 100;

export function round(num: number, precision = 0) {
  let x = new Decimal(num || 0);
  return x.toDecimalPlaces(5).toDecimalPlaces(precision).toNumber();
}

export const percentageCal = (percentageAmount: number, amt: number) =>
  round(Number(percentageAmount || 0) * 0.01 * Number(amt || 0), 2);

export const getHigherValueIndex = (items: any[], value: number, key: string) => {
  const sum = items?.reduce((ac: any, co: any) => ac + +co?.[key].toFixed(2), 0);
  const difference = +(value - sum).toFixed(2);
  if (difference !== 0 && !Number.isNaN(difference)) {
    const valuesArray = items.map((item: any) => item[key]);
    const higherValueIndex = valuesArray.findIndex(
      (val: number) => val === Math.max(...valuesArray)
    );
    return { difference, higherValueIndex };
  }
};

export const extractNumericPart = (str: string) => {
  const numericPart = str.match(/\d+/);

  if (numericPart) {
    return numericPart[0];
  } else {
    return null;
  }
};

export const formatPeriod = (period: string) => {
  const periodNumber = parseInt(period, 10);

  return periodNumber;
};
